var map = {
	"./goldentoad_en.png": "TwqH",
	"./goldentoad_esp.png": "/oSW",
	"./goldentoad_th.png": "TPVD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vu92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/goldentoad_.*\.png$
// module id = Vu92
// module chunks = 1